import { SwUpdateMixin } from "vue-app-utils-web";
import registerServiceWorker from "@/utils/register-service-worker";

const originalCreated = SwUpdateMixin.created;

export default {
  ...SwUpdateMixin,
  created () {
    if (originalCreated) originalCreated.call(this);
    registerServiceWorker();
  }
};
